document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bb-mobile-menu nav a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.open = false;
    });
  });
});


/* Brazilian Botanics: force AJAX add-to-cart into the cart drawer. */
(() => {
  if (window.__bbDrawerAddToCartInstalled) return;
  window.__bbDrawerAddToCartInstalled = true;

  const showFormError = (form, message) => {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const target = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !target) return;
    target.textContent = message || 'Unable to add this item to your cart. Please try again.';
    wrapper.hidden = false;
  };

  const clearFormError = (form) => {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || !form.closest('product-form')) return;

    // The Brazilian Botanics storefront is intentionally drawer-first.
    const drawerMount = document.querySelector('cart-drawer');
    if (!drawerMount) return;

    // Capture phase prevents the native form and Dawn's product-form handler
    // from sending the customer to the standalone cart page.
    event.preventDefault();
    event.stopImmediatePropagation();
    clearFormError(form);

    const submitButton = form.querySelector('[type="submit"]');
    const spinner = submitButton?.querySelector('.loading__spinner');
    submitButton?.setAttribute('aria-disabled', 'true');
    submitButton?.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      const formData = new FormData(form);
      formData.set('sections', 'cart-drawer,cart-icon-bubble');
      formData.set('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      });

      const state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || 'Unable to add this item to your cart.');
      }

      if (window.customElements?.whenDefined) {
        await customElements.whenDefined('cart-drawer');
      }

      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        throw new Error('The cart drawer did not initialize. Please refresh the page and try again.');
      }

      drawer.setActiveElement?.(submitButton || document.activeElement);
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
    } catch (error) {
      console.error('[Brazilian Botanics] Add to cart failed:', error);
      showFormError(form, error.message);
    } finally {
      submitButton?.removeAttribute('aria-disabled');
      submitButton?.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  }, true);
})();
